<div class="row" *ngIf="form as form" [formGroup]="form">
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"nip" as controlName'>
      <label [for]='controlName'>
        Numer NIP *
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu numer NIP'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  @if (form.firstName.enabled) {
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"firstName" as controlName'>
        <label [for]='controlName'>
          Imię/Imiona *
        </label>
        <input
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu imię/imiona'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  }
  @if (form.lastName.enabled) {
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"lastName" as controlName'>
        <label [for]='controlName'>
          Nazwisko *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwisko'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  }
  @if (form.name.enabled) {
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"name" as controlName'>
        <label [for]='controlName'>
          Nazwa *
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwę'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  }
  @if (form.regon.enabled) {
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"regon" as controlName'>
        <label [for]='controlName'>
          REGON
        </label>
        <input
          [id]='controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu REGON'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  }
</div>
